<template>
    <b-row>
        <b-col cols="12">
            <div class="text-center text-primary my-2" v-if="!component">
                <b-skeleton width="100%" height="250px" class="align-middle" animation="throb"/>
            </div>

            <div v-else>
                <PowerApp 
                    :id="getComponentID()"
                    :nodes="component.settings.templates" 
                    v-if="isCustomTemplate" 
                    :entrypoint="templateEntrypoint" 
                    :modelUuid="modelId" 
                    :component="component"
                    
                    noRouter

                    v-on="$listeners"

                    v-bind="$attrs"
                />

                <DefaultEdit :id="getComponentID()" :modelUuid="modelId" :component="component" @modelChanged="modelChanged" @saved="saved" v-bind="$attrs" v-else >
                    <template #controls="props">
                        <slot name="controls" v-bind="props"></slot>
                    </template>
                </DefaultEdit>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import DefaultEdit from './DefaultEdit.vue'

export default {
    name: 'Edit',
    components: {
        DefaultEdit,
        PowerApp: () => import('./ComponentView')
    },
    props: {
        id: {
            type: String,
            default: null
        },
        modelUuid: {
            type: String,
            default: null
        },
        entrypoint: {
            type: String,
        }
    },
    data: () => {
        return {
            component: null
        }
    },
    computed: {
        isCustomTemplate() {
            return this.templateEntrypoint != ''
        },

        templateEntrypoint() {
            if (this.entrypoint == 'default') return ''
            if (this.entrypoint) return this.entrypoint

            return this.component.settings.appearance.edit_entrypoint
        },

        modelId() {
            return this.modelUuid || this.$route.params.uuid
        }
    },
    methods: {
        getComponentID() {
            return this.id || this.$route.meta.ref
        },

        modelChanged(model) {
            this.$emit('modelChanged', model)
        },

        saved(model) {
            this.$emit('saved', model)
        }
    },
    created() {
        this.$store.dispatch("fetchComponentsSettings", this.getComponentID()).then(data => {
            this.component = data

            this.$route.meta.label = this.$translateLabel(this.component.general.label)
        }).catch(err => {
            this.$bvToast.toast(this.$t('unexpectedError'), {
                variant: 'danger'
            })
        }) 
    
    },

    updated() {
        console.log("[Render] Edit rendered")
    }
}
</script>
